var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.wrapperElement,_vm._b({ref:"rootEl",tag:"component",staticClass:"relative"},'component',_setup.wrapperAttributes,false),[_c('ul',_vm._b({ref:"list",class:[
      'list-none',
      // Placement
      'flex',
      'justify-between',
      // Spacing
      'm-0',
      'p-0',
      // Custom classes
      _vm.tabsContainerClasses,
    ],attrs:{"role":_setup.listRole}},'ul',_setup.listAttributes,false),_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.key,ref:(el) => _setup.setTabRef(el, index, tab),refInFor:true,class:[
        // Placement
        'flex',
        'items-center',
        // Size
        _vm.placementMode === _setup.OzTabsPlacementMode.Stretch && 'flex-1',
      ],attrs:{"data-testid":tab.testId,"data-pw":tab.testId,"role":_setup.listItemRole}},[_c(_setup.OzPlainButton,_vm._b({class:[
          'flex',
          'justify-center',

          'outline-none',
          'rounded-xl',
          // Size
          'w-full',
          // Spacing
          'px-2 pt-2 pb-2.25',
          // Font
          'font-semibold',
          'text-center',
          _vm.sizePreset === _setup.OzTabsSizePreset.Small && 'text-body-small',
          _vm.sizePreset === _setup.OzTabsSizePreset.ExtraSmall && 'text-body-extra-small',
          // Base
          _setup.currentTabId === tab.key
            ? {
                'text-grape-500': _vm.darkMode === false,
                'text-canary-500': _vm.darkMode === true,
                'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
              }
            : {
                'text-dark-text-200': _vm.darkMode === false,
                'text-light-text-200': _vm.darkMode === true,
                'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
              },
          // Hovered
          !tab.disabled && {
            'hover-hover:hover:text-grape-500': _vm.darkMode === false,
            'hover-hover:hover:text-canary-500': _vm.darkMode === true,
            'hover-hover:hover:text-grape-500 hover-hover:dark:hover:text-canary-500': _vm.darkMode === 'auto',
          },
          // Focused
          'ring-inset',
          'hover-hover:focus-visible:ring-2',
          {
            'hover-hover:focus-visible:ring-grape-500': _vm.darkMode === false,
            'hover-hover:focus-visible:ring-canary-500': _vm.darkMode === true,
            'hover-hover:focus-visible:ring-grape-500 hover-hover:dark:focus-visible:ring-canary-500':
              _vm.darkMode === 'auto',
          },
        ],attrs:{"href":tab.href,"color-scheme":_setup.OzPlainButtonColorScheme.Bare,"size-preset":_vm.sizePreset,"dark-mode":_vm.darkMode,"text":tab.iconName ? undefined : tab.text,"title":tab.text,"disabled":tab.disabled},on:{"click":function($event){return _setup.emit('activate-tab', $event, { key: tab.key })}}},'OzPlainButton',_setup.computeTabAttributes(tab),false),[(tab.iconName)?_c(_setup.OzIcon,{attrs:{"name":_setup.currentTabId === tab.key && tab.activeIconName ? tab.activeIconName : tab.iconName,"size":tab.iconSize}}):_vm._e()],1)],1)}),0),_vm._v(" "),_c('div',{ref:"indicator",class:[
      // Position
      'absolute',
      'bottom-0',
      // Shape
      'rounded',
      // Size
      _vm.sizePreset === _setup.OzTabsSizePreset.Small && 'h-[1.5px]',
      _vm.sizePreset === _setup.OzTabsSizePreset.ExtraSmall && 'h-0.25',
      // Appearance
      {
        'bg-grape-500': _vm.darkMode === false,
        'bg-canary-500': _vm.darkMode === true,
        'bg-grape-500 dark:bg-canary-500': _vm.darkMode === 'auto',
      },
      // Animation
      'transition-all',
      'motion-reduce:transition-none',
    ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }